"use client";

import {
  BlocksRenderer,
  type BlocksContent,
} from "@strapi/blocks-react-renderer";
import Link from "next/link";
import { type FC, type ComponentProps } from "react";

interface CustomBlocksRendererProps {
  content: BlocksContent;
}

// Getting the proper types from the BlocksRenderer component
type BlocksProps = ComponentProps<typeof BlocksRenderer>;
type BlockComponents = NonNullable<BlocksProps["blocks"]>;

const CustomBlocksRenderer: FC<CustomBlocksRendererProps> = ({ content }) => {
  const blocks: Partial<BlockComponents> = {
    link: ({ children, url, ...props }) => (
      <Link href={url} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </Link>
    ),
  };

  return <BlocksRenderer content={content} blocks={blocks} />;
};

export default CustomBlocksRenderer;
